import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation } from '@tanstack/react-query';

import { stopService } from '../../../../../../../../../application/StopService';
import { Stop } from '../../../../../../../../../domain/stop/Stop';
import { useErrorMiddlewareOld } from '../../../../../../../../../hooks/useErrorMiddlewareOld';

interface UseValidatePinProps {
  stop: Stop;
  pin: string;
}

type UseValidatePinResponseProps = ServiceResponse<Function, void>;

// Hooks act as 'Adapter' layer.
export const useValidatePin = ({ stop, pin }: UseValidatePinProps): UseValidatePinResponseProps => {
  const { sessionExpiredLogout } = useErrorMiddlewareOld();

  const { isLoading, isSuccess, isError, mutate } = useMutation(
    (): Promise<void> => stopService.validatePin({ stop, pin: pin.replace(/ /g, ``) }),
    {
      onError: (err: any) => {
        console.info(`Report Validate PIN Error: `, err?.response);
        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: mutate,
  };
};
